import { STATS } from "@/lib/constants";

export const COUNTRY_STATS: Record<
  string,
  { ips: string; cities: string; uptime: string; latency: string }
> = {
  "United States": { ips: "3.85M+", cities: "850+", uptime: STATS.uptime, latency: "<0.3s" },
  Germany: { ips: "1.21M+", cities: "120+", uptime: STATS.uptime, latency: "<0.4s" },
  Brazil: { ips: "1.42M+", cities: "280+", uptime: STATS.uptime, latency: "<0.5s" },
  "United Kingdom": { ips: "980K+", cities: "180+", uptime: STATS.uptime, latency: "<0.4s" },
  France: { ips: "840K+", cities: "110+", uptime: STATS.uptime, latency: "<0.4s" },
  Japan: { ips: "1.12M+", cities: "200+", uptime: STATS.uptime, latency: "<0.4s" },
  India: { ips: "1.67M+", cities: "320+", uptime: STATS.uptime, latency: "<0.5s" },
  Canada: { ips: "730K+", cities: "150+", uptime: STATS.uptime, latency: "<0.4s" },
  Australia: { ips: "510K+", cities: "80+", uptime: STATS.uptime, latency: "<0.5s" },
  China: { ips: "2.24M+", cities: "400+", uptime: STATS.uptime, latency: "<0.4s" },
  Russia: { ips: "890K+", cities: "180+", uptime: STATS.uptime, latency: "<0.5s" },
  Italy: { ips: "620K+", cities: "90+", uptime: STATS.uptime, latency: "<0.4s" },
  Spain: { ips: "580K+", cities: "85+", uptime: STATS.uptime, latency: "<0.4s" },
  Netherlands: { ips: "430K+", cities: "45+", uptime: STATS.uptime, latency: "<0.3s" },
  "South Korea": { ips: "710K+", cities: "95+", uptime: STATS.uptime, latency: "<0.3s" },
  Mexico: { ips: "640K+", cities: "130+", uptime: STATS.uptime, latency: "<0.5s" },
  Indonesia: { ips: "530K+", cities: "120+", uptime: STATS.uptime, latency: "<0.5s" },
  Turkey: { ips: "480K+", cities: "80+", uptime: STATS.uptime, latency: "<0.4s" },
  "Saudi Arabia": { ips: "390K+", cities: "25+", uptime: STATS.uptime, latency: "<0.5s" },
  Argentina: { ips: "410K+", cities: "85+", uptime: STATS.uptime, latency: "<0.5s" },
  "South Africa": { ips: "260K+", cities: "30+", uptime: STATS.uptime, latency: "<0.6s" },
};

export const DEFAULT_STATS = [
  { value: STATS.ips, label: "Total IPs" },
  { value: STATS.countries, label: "Countries" },
  { value: STATS.uptime, label: "Uptime guarantee" },
  { value: "<0.5s", label: "Avg latency" },
];

export const topCountries = [
  { flag: "🇺🇸", name: "United States", ips: "3.85M" },
  { flag: "🇩🇪", name: "Germany", ips: "1.21M" },
  { flag: "🇧🇷", name: "Brazil", ips: "1.42M" },
  { flag: "🇬🇧", name: "United Kingdom", ips: "980K" },
  { flag: "🇫🇷", name: "France", ips: "840K" },
  { flag: "🇯🇵", name: "Japan", ips: "1.12M" },
  { flag: "🇮🇳", name: "India", ips: "1.67M" },
  { flag: "🇨🇦", name: "Canada", ips: "730K" },
];

export const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45 } },
};
